import React from 'react';
import Logger from '../../util/Logger';
import './MultiRatingHeader.css';
import StarRatings from 'react-star-ratings';

export default class MultiRatingHeader extends React.Component {

  constructor (props) {
    super(props);
    const { index, idea } = props;
    if (index === undefined || isNaN(index)) {
      Logger.assert('Missing index in MultiRatingHeader component');
    }
    if (!idea) {
      Logger.assert('Missing idea in MultiRatingHeader component');
    }
  }

  render () {
    const { index, idea } = this.props;
    return (
      <div className="row multi-rating-header">
        <div className="col-md-9 d-inline-flex">
          <div className="rank">
            { index+1 }
          </div>
          <div className="font-bold-title font-size-xl">
            { idea.name }
          </div>
        </div>
        <div className="col-md-3 pl-5">
          <div className="row">
            <StarRatings
              rating={idea.avg_rating}
              starRatedColor="#F3C300"
              starDimension="28px"
              starSpacing="0px"
            />
            <div className="average">{idea.avg_rating.toFixed(1)}</div>
          </div>
        </div>
      </div>
    )
  }
}
